import { useContext } from 'react';
import { FormFieldContext } from './FormFieldContext';

/**
 * A hook to retrieve form field information.
 */
export const useFormField = () => {
  const formField = useContext(FormFieldContext);

  return formField;
};
